<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar" enctype="multipart/form-data">
			<div class="modal-body">
				<div class="form-horizontal" v-if="user">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>
					<div class="form-group">
						<select-form v-model="form.empresa_id" :value="form.empresa_id" name="Empresa"
							:url="`/empresas?ativo=1&amp;empresa_id=${user.empresa_id}`" id="id" titulo="titulo"
							layout="true" optionText="Selecione" required="true" :session="true"></select-form>
					</div>
					<input-form-text textInput="Equipamento" :required="true" v-model="form.equipamento"
						:value="form.equipamento"></input-form-text>
					<input-form-text textInput="Modelo" v-model="form.modelo" :value="form.modelo"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="patrimonio">Patrimônio</label>
						<div class="col-sm-4">
							<money class="form-control col-xs-10 col-sm-3" v-bind="patrimonio" required=""
								v-model="form.patrimonio" placeholder="Patrimônio" maxlength="7"
								v-debounce:1000ms="checkPatrimonio"></money>
							<div class="erro" v-if="verPatrimonio"><br />Patrimonio já cadastrado!</div>
						</div>
					</div>
					<input-form-text textInput="Marca" v-model="form.marca" :value="form.marca"></input-form-text>
					<input-form-text textInput="Nº de Série" v-model="form.referencia"
						:value="form.referencia"></input-form-text>
					<div class="form-group">
						<select-form v-model="form.voltagem_id" :value="form.voltagem_id" name="Voltagem" url="/voltagem"
							id="id" titulo="titulo" layout="true" optionText="Selecione" :session="true"></select-form>
					</div>
					<input-form-text textInput="Fornecedor" v-model="form.fornecedor"
						:value="form.fornecedor"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="valor_compra">Valor da compra
							(R$)</label>
						<div class="col-sm-4">
							<money class="form-control col-xs-10 col-sm-3" v-bind="money" v-model="form.valor_compra"
								placeholder="Valor de Compra"></money>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="valor_locacao">Valor da locação
							(R$)</label>
						<div class="col-sm-4">
							<money class="form-control col-xs-10 col-sm-3" v-bind="money" v-model="form.valor_locacao"
								placeholder="Valor de Locação"></money>
						</div>
					</div>
					<input-form-text textInput="Nº nota fiscal" v-model="form.nota_fiscal"
						:value="form.nota_fiscal"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="aquisicao">Data aquisição</label>
						<div class="col-sm-4">
							<input class="form-control col-xs-10 col-sm-5" v-model="form.aquisicao"
								placeholder="Data aquisição" type="date" @keyup="isValidDate" @change="isValidDate" />
						</div>
					</div>
					<legend>Aferição</legend>
					<input-form-text textInput="Situação da aferição" v-model="form.situacao_af"
						:value="form.situacao_af"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="ultima_af">Última aferição</label>
						<div class="col-sm-4">
							<input class="form-control col-xs-10 col-sm-5" v-model="form.ultima_af"
								placeholder="Última aferição" type="date" @keyup="isValidDate" @change="isValidDate" />
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="proxima_af">Próxima aferição</label>
						<div class="col-sm-4">
							<input class="form-control col-xs-10 col-sm-5" v-model="form.proxima_af"
								placeholder="Próxima aferição" type="date" @keyup="isValidDate" @change="isValidDate" />
						</div>
					</div>
					<input-form-text textInput="Verificação" v-model="form.verificacao"
						:value="form.verificacao"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="prox_verificacao">Próxima
							verificação</label>
						<div class="col-sm-4">
							<input class="form-control col-xs-10 col-sm-5" v-model="form.prox_verificacao"
								placeholder="Próxima verificação" type="date" @keyup="isValidDate" @change="isValidDate" />
						</div>
					</div>
					<legend>Calibrações</legend>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="cal_data">Data</label>
						<div class="col-sm-4">
							<input class="form-control col-xs-10 col-sm-5" v-model="form.cal_data" placeholder="Data"
								type="date" @keyup="isValidDate" @change="isValidDate" />
						</div>
					</div>
					<input-form-text textInput="Número do laudo" v-model="form.cal_laudo"
						:value="form.cal_laudo"></input-form-text>
					<!-- <div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Link Laudo</label>
						<div class="col-sm-9">
							<input @change="uploadFile" type="file" name="cal_link" accept="application/pdf" />
						</div>
					</div> -->
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Link Laudo</label>
						<div class="col-sm-5">
							<file-upload v-if="!allFiles.length" ref="fupload" :url="'/equipamentos/upload'" :id="null"
								:label="'PDF até 10 MB'" :multiple="false" texto="Enviar Arquivos" accept=".pdf"
								:isFile="true"></file-upload>
							<items-edit v-else :files="allFiles" url="/equipamentos/upload" id="id"
								:isFile="true"></items-edit>
						</div>
					</div>
					<legend>Status</legend>
					<div class="form-group">
						<select-form v-model="form.status_situacao_id" :value="form.status_situacao_id"
							name="Situação do equipamento" url="/situacoes" id="id" titulo="titulo" layout="true"
							optionText="Selecione" required="true" :session="true"></select-form>
					</div>
					<div class="form-group">
						<select-form v-model="form.status_id" :value="form.status_id" name="Condições" url="/status" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"
							:session="true"></select-form>
					</div>
					<legend>Observações</legend>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="obs"> Observação</label>
						<div class="col-sm-9">
							<textarea class="form-control" v-model="form.obs" placeholder="Observação"
								v-autosize></textarea>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Fotos 1</label>
						<div class="col-sm-5">
							<file-upload v-if="!allImages1.length" ref="fuploadImage1" :url="'/equipamentos/upload-img1'" :id="null"
								:label="'PNG, JPG, GIF até 10 MB'" :multiple="false" width="800"></file-upload>
							<items-edit v-else :files="allImages1"
								url="/equipamentos/upload-img1" id="id"></items-edit>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Fotos 2</label>
						<div class="col-sm-5">
							<file-upload v-if="!allImages2.length" ref="fuploadImage2" :url="'/equipamentos/upload-img2'" :id="null"
								:label="'PNG, JPG, GIF até 10 MB'" :multiple="false" width="800"></file-upload>
							<items-edit v-else :files="allImages2"
								url="/equipamentos/upload-img2" id="id"></items-edit>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Fotos 3</label>
						<div class="col-sm-5">
							<file-upload v-if="!allImages3.length" ref="fuploadImage3" :url="'/equipamentos/upload-img3'" :id="null"
								:label="'PNG, JPG, GIF até 10 MB'" :multiple="false" width="800"></file-upload>
							<items-edit v-else :files="allImages3"
								url="/equipamentos/upload-img3" id="id"></items-edit>
						</div>
					</div>
					<!-- <upload-image name="Fotos 1" v-model="form.fotos"></upload-image>
					<upload-image name="Fotos 2" v-model="form.fotos1"></upload-image>
					<upload-image name="Fotos 3" v-model="form.fotos2"></upload-image> -->
					<legend>Localização</legend>
					<div class="form-group" v-if="$route.params.id">
						<select-multi-form ref="multi" v-model="form.cidades" name="Cidade"
							url="/cidades?keyword=" id="id" titulo="cidade" :resetar="false"
							layout="true"></select-multi-form>
					</div>
					<div class="form-group" v-else>
						<select-multi-form ref="multi" v-model="form.cidades" name="Cidade" url="/cidades?keyword=" id="id"
							titulo="cidade" :resetar="false" layout="true"></select-multi-form>
					</div>
					<input-form-text textInput="Obra" v-model="form.obra" :value="form.obra"></input-form-text>
				</div>
			</div>
			<footer-button :disabled="isActive"></footer-button>
		</form>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import { Money } from 'v-money'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import SelectMultiForm from '@/components/form/SelectMultiForm'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		Money,
		fileUpload,
		ItemsEdit,
		SelectMultiForm
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	watch: {
		'form.empresa_id'() {
			setTimeout(() => {
				this.checkPatrimonio()
			}, 1e3)
		}
	},
	data() {
		return {
			title: 'Equipamentos',
			form: {
				empresa_id: '',
				equipamento: '',
				modelo: '',
				patrimonio: '',
				marca: '',
				voltagem_id: '',
				referencia: '',
				fornecedor: '',
				valor_compra: '',
				valor_locacao: '',
				nota_fiscal: '',
				condicao: '',
				aquisicao: '',
				situacao_af: '',
				ultima_af: '',
				proxima_af: '',
				verificacao: '',
				prox_verificacao: '',
				cal_data: '',
				cal_laudo: '',
				cal_link: '',
				status_situacao_id: '',
				status_situacao: '',
				status_id: '',
				status_nome: '',
				status_medicao: '',
				fotos: '',
				fotos1: '',
				fotos2: '',
				obs: '',
				cidades: '',
				obra: ''
			},
			isActive: false,
			money: {
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				suffix: '',
				precision: 2,
				masked: false
			},
			patrimonio: {
				decimal: '',
				thousands: '',
				prefix: '',
				suffix: '',
				precision: 5,
				masked: true
			},
			day: null,
			month: null,
			year: null,
			isLeapYear: false,
			monthLength: null,
			isISO8601: false,
			verPatrimonio: null,
			allImages1: [],
			allImages2: [],
			allImages3: [],
			allFiles: [],
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			if (this.verPatrimonio) {
				return
			}
			this.isActive = true
			this.isActiveBtn = true
			this.form.cidade_id = this.form.cidades.id
			this.form.cidade = this.form.cidades.cidade
			delete this.form.cidades

			const body = this.form
			if (this.$route.params.id) {
				let resp = await req(`/equipamentos/${this.$route.params.id}`, 'put', body).catch(response => {
					'error: ' + response
					erro()
				})

				if(this.$refs.fupload) {
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					resp.folder = this.form.folder
					await m.uploadAll(resp)
				}
				if (!this.allImages1.length) {
					this.isActive = false
					const tb = this.$refs.fuploadImage1.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				if (!this.allImages2.length) {
					this.isActive = false
					const tbPessoa = this.$refs.fuploadImage2.$children.filter(i => i.$refs.tb)
					const mPessoa = tbPessoa[0]
					await mPessoa.uploadAll(resp)
				}
				if (!this.allImages3.length) {
					this.isActive = false
					const tbFluxo = this.$refs.fuploadImage3.$children.filter(i => i.$refs.tb)
					const mFluxo = tbFluxo[0]
					await mFluxo.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/sistema/equipamentos')
			} else {
				let resp = await req('/equipamentos', 'post', body).catch(response => {
					'error: ' + response
					erro()
				})
				this.getLogsTotal(this.user.id)
				const tbu = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const mu = tbu[0]
				await mu.uploadAll(resp)
				const tb = this.$refs.fuploadImage1.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				const tbPessoa = this.$refs.fuploadImage2.$children.filter(i => i.$refs.tb)
				const mPessoa = tbPessoa[0]
				await mPessoa.uploadAll(resp)
				const tbFluxo = this.$refs.fuploadImage3.$children.filter(i => i.$refs.tb)
				const mFluxo = tbFluxo[0]
				await mFluxo.uploadAll(resp)
				this.isActive = false
				this.isActiveBtn = false
				sucesso('Atualizado...')
				this.$router.push('/sistema/equipamentos')

			}
			
		},
		async checkPatrimonio() {
			if (!this.form.empresa_id || !this.form.patrimonio || this.$route.params.id) {
				return
			}
			const dados = await req(`/equipamentos/patrimonio/${this.form.patrimonio}/${this.form.empresa_id}`)
			this.verPatrimonio = dados
		},
		getDados() {
			req(`/equipamentos/${this.$route.params.id}`).then(resp => {
				this.form.empresa_id = resp.empresa_id
				this.form.equipamento = resp.equipamento
				this.form.modelo = resp.modelo
				this.form.patrimonio = resp.patrimonio
				this.form.marca = resp.marca
				this.form.referencia = resp.referencia
				this.form.fornecedor = resp.fornecedor
				this.form.voltagem_id = resp.voltagem_id
				this.form.valor_compra = Number(resp.valor_compra).toLocaleString('pt-br', { minimumFractionDigits: 2 })
				this.form.valor_locacao = Number(resp.valor_locacao).toLocaleString('pt-br', { minimumFractionDigits: 2 })
				this.form.nota_fiscal = resp.nota_fiscal
				this.form.condicao = resp.condicao
				this.form.aquisicao = resp.aquisicao
				this.form.situacao_af = resp.situacao_af
				this.form.ultima_af = resp.ultima_af
				this.form.proxima_af = resp.proxima_af
				this.form.verificacao = resp.verificacao
				this.form.prox_verificacao = resp.prox_verificacao
				this.form.cal_data = resp.cal_data
				this.form.cal_laudo = resp.cal_laudo
				this.form.cal_link = resp.cal_link
				this.form.status_situacao_id = resp.status_situacao_id
				this.form.status_situacao = resp.status_situacao
				this.form.status_id = resp.status_id
				this.form.status_nome = resp.status_nome
				this.form.status_medicao = resp.status_medicao
				this.form.fotos = resp.fotos
				this.form.fotos1 = resp.fotos1
				this.form.fotos2 = resp.fotos2
				this.form.obs = resp.obs
				this.allImages1 = resp.fotos ? [{ id: this.$route.params.id, images: resp.fotos }] : ''
				this.allImages2 = resp.fotos1 ? [{ id: this.$route.params.id, images: resp.fotos1 }] : ''
				this.allImages3 = resp.fotos2 ? [{ id: this.$route.params.id, images: resp.fotos2 }] : ''
				this.allFiles = resp.cal_link ? [{ id: this.$route.params.id, files: resp.cal_link }] : ''

				this.form.obra = resp.obra
				this.isActive = false
				setTimeout(() => {
					this.form.cidades = { id: resp.cidade_id, cidade: resp.cidade }
				}, 300)
			}).catch(response => {
				'error: ' + response
				erro()
			})
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		},
		isValidDate() {
			if (!/^(\d{1,2}\/\d{1,2}\/\d{4,}|\d{4,}-\d{1,2}-\d{1,2})$/.test(this.date)) {
				return false
			}

			this.isISO8601 = /^\d{4}-\d{1,2}-\d{1,2}$/.test(this.date)

			// Get the month, day, and year parts
			var parts = this.date.split(this.isISO8601 ? '-' : '/')
			this.month = parseInt(parts[this.isISO8601 ? 1 : 0], 10)
			this.day = parseInt(parts[this.isISO8601 ? 2 : 1], 10)
			this.year = parseInt(parts[this.isISO8601 ? 0 : 2], 10)

			// Should be a valid javascript month 0-11
			if (this.month === 0 || this.month > 12) {
				return false
			}

			// Valid month lengths
			var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

			// Check for leap years
			if (this.year % 400 === 0 || (this.year % 100 !== 0 && this.year % 4 === 0)) {
				this.isLeapYear = true
				monthLength[1]++
			} else {
				this.isLeapYear = false
			}

			return this.day > 0 && this.day <= monthLength[this.month - 1]
		},
		blobToBase64(blob) {
			return new Promise((resolve) => {
				const reader = new FileReader()
				reader.onloadend = () => resolve(reader.result)
				reader.readAsDataURL(blob)
			})
		},
		getFotos(e) {
			this.form.fotos = e
		},
		uploadFile() {
			var file = document.querySelector('input[name=cal_link]').files[0]
			var reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onloadend = () => {
				//	uploadFile(reader.result, 'pdf', 'pdf', files[0].name)
				this.form.cal_link = reader.result
			}
			reader.onerror = function (error) {
				'Error: ', error
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

.erro {
	color: red;
}
</style>
